import { render, staticRenderFns } from "./expansion-panel-header.vue?vue&type=template&id=74e052cb&scoped=true"
import script from "./expansion-panel-header.vue?vue&type=script&lang=js"
export * from "./expansion-panel-header.vue?vue&type=script&lang=js"
import style0 from "./expansion-panel-header.vue?vue&type=style&index=0&id=74e052cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e052cb",
  null
  
)

export default component.exports